/** DateTimeBox values are 'YYYY-MM-DD HH:mm:ss' strings; read them as local dates for date math. */
export const parseSetupDate = (value: string | undefined): Date | undefined =>
    value ? new Date(value.replace(' ', 'T')) : undefined;
